"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isUndefined = require("lodash/isUndefined");

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isArray = require("lodash/isArray");

var _isArray2 = _interopRequireDefault(_isArray);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiCheckbox = function (_Component) {
    _inherits(MultiCheckbox, _Component);

    function MultiCheckbox(props) {
        _classCallCheck(this, MultiCheckbox);

        var _this = _possibleConstructorReturn(this, (MultiCheckbox.__proto__ || Object.getPrototypeOf(MultiCheckbox)).call(this, props));

        _this.state = {
            values: []
        };

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(MultiCheckbox, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value && Array.isArray(nextProps.value)) {
                this.setState({
                    values: nextProps.value
                });
            }
        }
    }, {
        key: "handleChange",
        value: function handleChange(event, value) {
            var onChange = this.props.onChange;

            var newValues = this.state.values.slice();
            if (event.target.checked) {
                newValues.push(value);
            } else {
                newValues.splice(newValues.indexOf(value), 1);
            }
            this.setState({
                values: newValues
            });
            return onChange({ name: this.props.name, value: newValues });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                options = _props.options,
                onBlur = _props.onBlur,
                error = _props.error,
                rest = _objectWithoutProperties(_props, ["options", "onBlur", "error"]);

            var values = this.state.values;


            var checkboxes = options.map(function (option) {
                var isChecked = values.indexOf(option.value) > -1;

                return _react2.default.createElement(
                    "div",
                    { key: option.value },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            onChange: function onChange(event) {
                                return _this2.handleChange(event, option.value);
                            },
                            checked: isChecked,
                            value: option.value
                        }),
                        option.text
                    )
                );
            });

            return _react2.default.createElement(
                "div",
                null,
                this.props.label && _react2.default.createElement(
                    _label2.default,
                    rest,
                    this.props.label
                ),
                checkboxes,
                _react2.default.createElement(_inputError2.default, { error: error })
            );
        }
    }]);

    return MultiCheckbox;
}(_react.Component);

MultiCheckbox.displayName = "MultiCheckbox";

MultiCheckbox.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        text: _propTypes2.default.string.isRequired
    })).isRequired,
    error: _propTypes2.default.string
};

exports.default = MultiCheckbox;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/checkbox.js
// module id = 997
// module chunks = 95715928098905 168707334958949